/**
 * @generated SignedSource<<8f80b29039af04bdf719b77cb9828c0b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedSellerDetails_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerTabs_sku">;
  readonly " $fragmentType": "PdpRespSharedSellerDetails_sku";
};
export type PdpRespSharedSellerDetails_sku$key = {
  readonly " $data"?: PdpRespSharedSellerDetails_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerDetails_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedSellerDetails_sku",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabs_sku"
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "e26bd0bcce52367ac9c806dbad88e8ba";

export default node;
